import { render, staticRenderFns } from "./part-orders.vue?vue&type=template&id=7010cf40&scoped=true"
import script from "./part-orders.vue?vue&type=script&lang=js"
export * from "./part-orders.vue?vue&type=script&lang=js"
import style0 from "./part-orders.vue?vue&type=style&index=0&id=7010cf40&prod&lang=css"
import style1 from "./part-orders.vue?vue&type=style&index=1&id=7010cf40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7010cf40",
  null
  
)

export default component.exports